<template>
  <div class="p-grid p-nogutter p-dir-col">
    <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
      <h5 class="p-m-0 p-mr-2">Home / Dashboard</h5>
      <div>
      <Dropdown
        v-model.number="idCnpjSelecionado"
        :options="cnpjs"
        optionLabel="cnpjNome" 
        optionValue="id"
        :autoDisplay="false"
        :showClear="false"
        class="dropdown-inline p-ml-2 p-mr-2"        
        :filter="false"
        placeholder="Selecione"
        :resetFilterOnHide="true"
        :hideOnSelect="false"
        @change="buscar"
      />    
      <Button
        icon="pi pi-refresh"
        class="p-button-sm"
        @click="refresh"
        title="Atualizar dados"
      />
      </div>
    </div>
    <hr class="sem-espaco-hr">

    <!-- 1. Aviso de rotinas pendentes -->
    <div class="p-col-12" v-if="temRotinasPendentes">
      <div class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle"></span>
          <span class="p-message-text">
            Há rotinas pendentes para você resolver!
            <Button label="Detalhes" icon="pi pi-search" class="p-ml-3 p-button-sm p-button-warning"/>
          </span>
        </div>
      </div>
    </div>

    <!-- 2. Atalhos personalizados -->
    <div class="p-col-12 p-grid p-mb-4" :class="temRotinasPendentes ? '' : 'p-mt-2'">
      <div v-for="atalho in atalhos" :key="atalho.label" class="p-col-12 p-sm-6 p-md-2">
        <div class="p-card p-shadow-3 p-p-3 p-text-center cursor-pointer atalho-card" style="height: 100%"
             @click="navegarPara(atalho.destino)">
          <i :class="['pi', atalho.icon, 'p-text-4xl p-mb-2']"></i>
          <div class="p-text-bold">{{ atalho.label }}</div>
        </div>
      </div>
    </div>

     <!-- 3. Indicadores e plano -->
    <div class="p-col-12 p-grid p-mb-3">

      <!-- Empresas -->
      <div class="p-col-12 p-md-3">
        <div class="card p-shadow-3" style="height: 100%">
          <div class="card-header">
            <i class="pi pi-building icon"></i>
            <span>Empresas</span>
          </div>
          <div class="card-body">
            <div class="linha-total">
              <strong>Total do Plano:</strong> {{ dados.totalCnpjsPlano }}
            </div>
            <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
              <span class="badge badge-green p-mr-2">Ativas: {{ dados.totalCnpjs }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Funcionários -->
      <div class="p-col-12 p-md-3">
        <div class="card p-shadow-3" style="height: 100%">
          <div class="card-header">
            <i class="pi pi-users icon"></i>
            <span>Funcionários</span>
          </div>
          <div class="card-body">
            <div class="linha-total">
              <strong>Total do Plano:</strong> {{ dados.totalFuncionariosPlano }}
            </div>
            <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
              <span class="badge badge-green p-mr-2">Admitidos: {{ dados.totalFuncionariosAtivos }}</span>
              <span class="badge badge-red p-mr-2">Demitidos: {{ dados.totalFuncionariosInativos }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Fucnionário com app -->
      <div class="p-col-12 p-md-3">
        <div class="card p-shadow-3" style="height: 100%">
          <div class="card-header">
            <i class="pi pi-cog icon"></i>
            <span>App</span>
          </div>
          <div class="card-body">
            <div class="linha-total">
              <strong>Total do Plano:</strong> {{ dados.totalDispositovosMobPlano + dados.totalDispositovosWebPlano }}
            </div>
            <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
              <span class="badge badge-green p-mr-2">Celular:  {{ dados.totalDispositovosMob }}/{{ dados.totalDispositovosMobPlano }} </span>
              <span class="badge badge-blue p-mr-2">Web:  {{ dados.totalDispositovosWeb }}/{{ dados.totalDispositovosWebPlano }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Usuários -->
      <div class="p-col-12 p-md-3">
        <div class="card p-shadow-3" style="height: 100%">
          <div class="card-header">
            <i class="pi pi-user icon"></i>
            <span>Usuários</span>
          </div>
          <div class="card-body">
            <div class="linha-total">
              <strong>Total do Plano:</strong> {{ dados.totalUsuariosPlano }}
            </div>
            <div class="linha-inline p-d-flex p-ai-center p-flex-wrap">
              <span class="badge badge-green p-mr-2">Ativas: {{ dados.totalUsuarios }}</span>
            </div>
          </div>
        </div>
      </div>      

    </div>      

    <!-- 4. Últimos acessos e marcações -->
    <div class="p-col-12 p-grid p-mb-3">

      <div class="p-col-12 p-md-2">
        <div class="p-card p-shadow-3 p-p-3" style="height: 100%">
          <div class="p-d-flex p-ai-center p-mb-5">           
            <h4 class="p-m-0">Resumo de Presenças</h4>
          </div>
          <div class="p-d-flex p-jc-around">
            <div class="p-text-center">
              <i class="pi pi-check-circle p-text-success p-text-3xl ik-text-success"></i>
              <div class="p-mt-2 p-text-bold">Presentes</div>
              <div class="p-text-xl">{{ dados.totalFuncionariosPresentes }}</div>
            </div>
            <div class="p-text-center">
              <i class="pi pi-times-circle p-text-danger p-text-3xl ik-text-primary"></i>
              <div class="p-mt-2 p-text-bold">Ausentes</div>
              <div class="p-text-xl">{{ dados.totalFuncionariosAusentes }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-5">
        <div class="p-card p-p-3 p-shadow-3" style="height: 100%">
          <h4>Últimos Acessos</h4>
          <DataTable :value="dados.ultimosAcessos" responsiveLayout="scroll" class="p-datatable-sm p-datatable-striped">
            <Column field="nomeUsuario" header="Nome"></Column>
            <Column field="data" header="Data/Hora">
              <template #body="slotProps">
                {{ formatarData(slotProps.data.data) }}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <div class="p-col-12 p-md-5">
        <div class="p-card p-p-3 p-shadow-3" style="height: 100%">
          <h4>Últimas Marcações</h4>
          <DataTable :value="dados.ultimasMarcacoes" responsiveLayout="scroll" class="p-datatable-sm p-datatable-striped">
            <Column field="nomeFuncionario" header="Nome"></Column>
            <Column field="data" header="Data/Hora">
              <template #body="slotProps">
                {{ formatarData(slotProps.data.data) }}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DashboardService from '@/service/DashboardService';
import { mapGetters } from 'vuex';
import { exibirMensagem } from '@/global';

export default {
  dashboardService: null,
  data() {
    return {
      idCnpjSelecionado: null,
      temRotinasPendentes: false,
      dados: {},
      atalhos: [
        { label: 'Controle de Ponto', icon: 'pi-clock', destino: '/movimento/controle-ponto' },
        { label: 'Upload AFD', icon: 'pi-upload', destino: '/documentos/arquivo-afd' },
        { label: 'Relatório Espelho de Ponto', icon: 'pi-file', destino: '/relatorios/espelho-ponto' },
        { label: 'Funcionários', icon: 'pi-users', destino: '/cadastros/funcionarios' },
        { label: 'Escalas de Horários', icon: 'pi-calendar', destino: '/cadastros/escalas-horarios' },
        { label: 'Afastamento', icon: 'pi-user-minus', destino: '/movimento/afastamentos' }       
      ],   
      grupoAtualizacaoTodos: 'gt',
      grupoAtualizacao1: 'g1',
      grupoAtualizacao2: 'g2',
      grupoAtualizacao3: 'g3',
      dataUltimoCliqueCalc: null  
    };
  },
  methods: {
    ...mapGetters('sessao', ['getDadosRequisicao','getCacheEmpresa']), 
    /**
     * 
     */
    navegarPara(destino) {
      if(destino == '/documentos/arquivo-afd') {        
        let temp = 'temp_lk_rp_'  + Date.now();
        sessionStorage.setItem('tem_lik_rapido_afd',  temp);	
        this.$router.push(`${destino}?lk_rp=${temp}`);
        return;
      }
      if(destino == '/relatorios/espelho-ponto') {        
        let temp = 'temp_lk_rp_'  + Date.now();
        sessionStorage.setItem('tem_lik_rapido_espelho',  temp);	
        this.$router.push(`${destino}?lk_rp=${temp}`);
        return;
      }
      this.$router.push(destino);
    },
    /**
     * 
     */
    getGruposAtualizar() {
      const dadosDaSessao = JSON.parse(sessionStorage.getItem(this.idCnpjSelecionado));
      if(!dadosDaSessao) {
        return [this.grupoAtualizacaoTodos];
      }
      const grupos = [];
      const agora = new Date();
      const timestampG1 = new Date(dadosDaSessao.timestampG1);      
      const diffHoras = Math.floor((agora - timestampG1) / (1000 * 60 * 60));
      if(diffHoras >= 6) {// 6h
        grupos.push(this.grupoAtualizacao1);
      } else {      
        this.atualizarComDadosDaSessao(this.grupoAtualizacao1, dadosDaSessao);
      }
      const timestampG2 = new Date(dadosDaSessao.timestampG2);
      const diffMinutos = Math.floor((agora - timestampG2) / 60000);
      if(diffMinutos >= 30) {// 30 minutos
        grupos.push(this.grupoAtualizacao2);
      } else {       
        this.atualizarComDadosDaSessao(this.grupoAtualizacao2, dadosDaSessao);
      }
      grupos.push(this.grupoAtualizacao3);
      return grupos;
    },
    /**
     * 
     */
    atualizarComDadosDaSessao(grupo, dadosDaSessao) {      
      if(grupo == this.grupoAtualizacao1) {
        this.dados.totalCnpjsPlano = dadosDaSessao.dados.totalCnpjsPlano;
        this.dados.totalDispositovosWebPlano = dadosDaSessao.dados.totalDispositovosWebPlano;
        this.dados.totalDispositovosMobPlano = dadosDaSessao.dados.totalDispositovosMobPlano;
        this.dados.totalFuncionariosPlano = dadosDaSessao.dados.totalFuncionariosPlano;
        this.dados.totalUsuariosPlano = dadosDaSessao.dados.totalUsuariosPlano;
        this.dados.totalCnpjs = dadosDaSessao.dados.totalCnpjs;
        this.dados.totalFuncionariosAtivos = dadosDaSessao.dados.totalFuncionariosAtivos;
        this.dados.totalFuncionariosInativos = dadosDaSessao.dados.totalFuncionariosInativos;       
        this.dados.totalUsuarios = dadosDaSessao.dados.totalUsuarios;	
        this.dados.totalDispositovosWeb = dadosDaSessao.dados.totalDispositovosWeb;
        this.dados.totalDispositovosMob = dadosDaSessao.dados.totalDispositovosMob;
        return;
      }
      if(grupo == this.grupoAtualizacao2) {
        this.dados.ultimosAcessos = dadosDaSessao.dados.ultimosAcessos;
        this.dados.ultimasMarcacoes = dadosDaSessao.dados.ultimasMarcacoes;
        this.dados.totalFuncionariosPresentes = dadosDaSessao.dados.totalFuncionariosPresentes;
        this.dados.totalFuncionariosAusentes = dadosDaSessao.dados.totalFuncionariosAusentes;
      }
    },
    /**
     * 
     */
    atualizarGrupos(grupos, respData) { 
      let dadosDaSessao = JSON.parse(sessionStorage.getItem(this.idCnpjSelecionado));
      const timestamp = Date.now();
      if(!dadosDaSessao) {        
        dadosDaSessao = {timestampG1: timestamp, timestampG2: timestamp, dados: respData};
      }
      grupos.forEach(g => {
        if(g == this.grupoAtualizacaoTodos) {        
          this.dados = respData;
          sessionStorage.setItem(this.idCnpjSelecionado, JSON.stringify(dadosDaSessao));          
          return;
        }
        if(g == this.grupoAtualizacao1) {
          dadosDaSessao.timestampG1 = timestamp;
          dadosDaSessao.dados.totalCnpjsPlano = respData.totalCnpjsPlano;
          dadosDaSessao.dados.totalDispositovosWebPlano = respData.totalDispositovosWebPlano;
          dadosDaSessao.dados.totalDispositovosMobPlano = respData.totalDispositovosMobPlano;
          dadosDaSessao.dados.totalFuncionariosPlano = respData.totalFuncionariosPlano;
          dadosDaSessao.dados.totalUsuariosPlano = respData.totalUsuariosPlano;
          dadosDaSessao.dados.totalCnpjs = respData.totalCnpjs;
          dadosDaSessao.dados.totalFuncionariosAtivos = respData.totalFuncionariosAtivos;
          dadosDaSessao.dados.totalFuncionariosInativos = respData.totalFuncionariosInativos;          
          dadosDaSessao.dados.totalUsuarios = respData.totalUsuarios;	
          dadosDaSessao.dados.totalDispositovosWeb = respData.totalDispositovosWeb;
          dadosDaSessao.dados.totalDispositovosMob = respData.totalDispositovosMob;
        }
        if(g == this.grupoAtualizacao2) {         
          dadosDaSessao.timestampG2 = timestamp;
          dadosDaSessao.dados.ultimasMarcacoes = respData.ultimasMarcacoes;
          dadosDaSessao.dados.totalFuncionariosPresentes = respData.totalFuncionariosPresentes;
          dadosDaSessao.dados.totalFuncionariosAusentes = respData.totalFuncionariosAusentes;
        }
      });
      // Grupo 3
      this.dados.ultimosAcessos = respData.ultimosAcessos;
      sessionStorage.setItem(this.idCnpjSelecionado, JSON.stringify(dadosDaSessao));    
    },
    /**
     * 
    */
    refresh() {
      // Proteção para dedo nervoso
      if(this.dataUltimoCliqueCalc) {			
				const diffTimeClick = new Date().getTime() - this.dataUltimoCliqueCalc.getTime();
				if(diffTimeClick < 5000) {          
					return;
				}
			}       
			this.dataUltimoCliqueCalc = new Date();
      this.buscar();
    },
    /**
     * 
     */
    buscar() {       
      const grupos = this.getGruposAtualizar();    
      const idCnpj = this.idCnpjSelecionado;
      const idEmprasa= this.getDadosRequisicao().empresa.id;      
      this.dashboardService.buscar(idEmprasa, idCnpj, grupos.join(','))
      .then(resp => {            
        this.atualizarGrupos(grupos, resp.data);     
      })
      .catch(erro => {
        if(erro.response && erro.response.status) {
          exibirMensagem(this, erro);
        } else {
          console.log(erro);
        }
      });
    },
    /**
     * 
     */
    listarCnpjs() {
      // Cache dados
      let cacheEmpresa = this.getCacheEmpresa();
      this.cnpjs = cacheEmpresa.cnpjs;     
      if(cacheEmpresa.idCnpjSelecionado) {
          this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
      } else {
        this.idCnpjSelecionado = this.cnpjs[0].id;
      }
      this.buscar();
    },    
    /**
     * 
     */
    formatarData(dataStr) {     
      if (!dataStr) return '';
      // Substitui espaço por "T" para padronizar formato
      const padraoIso = dataStr.replace(' ', 'T');
      // Tenta criar objeto Date
      const data = new Date(padraoIso);
      if (isNaN(data.getTime())) {
        return 'Data inválida';
      }
      // Usa Intl.DateTimeFormat para formatar para pt-BR
      const temHora = /T\d{2}:\d{2}/.test(padraoIso);
      const opcoes = temHora
        ? { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }
        : { day: '2-digit', month: '2-digit', year: 'numeric' };
      return new Intl.DateTimeFormat('pt-BR', opcoes).format(data);
    },
    /**
     * 
     */
    criarObjetoVazio() {
      return {
        totalCnpjsPlano: 0,
        totalDispositovosWebPlano: 0,
        totalDispositovosMobPlano: 0,
        totalFuncionariosPlano: 0,
        totalUsuariosPlano: 0,
        totalCnpjs: 0,
        totalFuncionariosAtivos: 0,
        totalFuncionariosInativos: 0,
        totalFuncionariosPresentes: 0,
        totalFuncionariosAusentes: 0,
        totalUsuarios: 0,
        totalDispositovosWeb: 0,
        totalDispositovosMob: 0,
        ultimosAcessos: [],
        ultimasMarcacoes: []
      }
    }
  },
  created() {  
    this.dados = this.criarObjetoVazio();
    this.dashboardService = new DashboardService();  
    this.listarCnpjs();   
  }
};
</script>

<style scoped>
.dropdown-inline {
  min-width: 400px;
  border: none;
}
.atalho-card {
  transition: all 0.3s ease;
  cursor: pointer;
}
.atalho-card:hover {
  background-color: #f4f4f4;
  transform: scale(1.05);
}
.p-card {
  border-radius: 8px;
  background: #fff;
}
.p-datatable th {
  text-align: left;
  font-weight: 600;
}
.p-datatable td {
  padding: 0.5rem 0.75rem;
}
/* card */
.card {
  border-radius: 12px;
  background: #fff;
  padding: 1.5rem;
  transition: transform 0.2s ease-in-out;
}

.card:hover {
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.card-body ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.card-body li {
  margin: 0.3rem 0;
}

.linha-total {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.linha-inline {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.badge {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
}

.badge-green {
  background-color: #4caf50;
}

.badge-gray {
  background-color: #9e9e9e;
}

.badge-red {
  background-color: #f44336;
}

.badge-blue {
  background-color: #2196f3;
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.card-header .icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.sem-espaco-hr {
  /* superior | direita | inferior | esquerda */
  padding: 0 0 0 0; 
  margin: 0 0 0 0;   
}
</style>
